<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-28 14:49:51
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <div class="search-box">
        <div style="margin-left: 0">
          <el-input
            v-model="search.activityName"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div>
          <el-date-picker
            v-model="search.startTime"
            type="date"
            placeholder="选择开始日期"
          ></el-date-picker>
        </div>
        <div>
          <el-date-picker
            v-model="search.endTime"
            type="date"
            placeholder="选择结束日期"
          ></el-date-picker>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-search" @click="getlist">搜索</el-button>
        </div>
      </div>
      <div class="formbox">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column
            prop="activityName"
            label="报名活动"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="teamRegionNameCh"
            label="团队省份"
            width="200"
          ></el-table-column>
          <el-table-column label="报名状态" width="200">
            <!-- 0.待提交，1.报名待审核 2.报名审核通过 3.缴费待审核 4.缴费审核已通过 5.报名审核未通过 6.缴费审核未通过 -->
            <template slot-scope="scope">
              <span v-if="scope.row.state == 0">待提交</span>
              <span v-if="scope.row.state == 1">报名待审核</span>
              <span v-if="scope.row.state == 2">报名审核通过</span>
              <span v-if="scope.row.state == 3">缴费待审核</span>
              <span v-if="scope.row.state == 4">缴费审核已通过</span>
              <span v-if="scope.row.state == 5">缴费审核未通过</span>
              <span v-if="scope.row.state == 6">报名审核未通过</span>
              <span v-if="scope.row.state == 7">已退赛</span>
               <span v-if="scope.row.state == 8">报名成功</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="submitTime"
            label="报名时间"
            width="250"
          ></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <!-- <el-button size="mini" type="primary">申请开票</el-button> -->
              <el-button
                size="mini"
                @click="getuserdetails(scope.row)"
                type="primary"
                >进入详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagebox">
          <el-pagination
            layout="prev, pager, next"
            @size-change="handleSize"
            @current-change="handleSizeChange"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :total="pagination.total"
          ></el-pagination>
        </div>
      </div>
      <div class="base">
        <ul>
         <li>你可以通过以下方式联系我们：</li>
          <li>
            <span>INTERKULTUR国际文化交流基金会（德国）亚洲中国事务部北方代表处</span></br>
            <span>电话： 010-63968766</span></br>
            <span>微信号/QQ：2318551129</span></br>
            <span>电子邮箱：zhangxiaoyan@interkultur.com.cn</span>
          </li>
          <li>
             <span>INTERKULTUR国际文化交流基金会（德国）亚洲中国事务部南方代表处</span></br>
            <span>电话： 020-83635878 </span></br>
            <span>微信号/QQ：634831329</span></br>
            <span>电子邮箱： hoju@interkultur.com.cn</span>
           
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/plugins/upload/bus";

import { applylist } from "@/api/file"; // 接口导入

export default {
  components: {
    circleRadio: () => import("@/components/circle-radio"),
  },
  computed: {},
  data() {
    return {
      search: {
        activityName: "",
        startTime: "",
        endTime: "",
      },

      currentPage1: 5,
      input: "",
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
    };
  },

  created() {},
  mounted() {
    this.getlist();
    localStorage.setItem("states", 2);
  },
  methods: {
    handleSizeChange(val) {
      this.pagination.pageNum = val;
      this.getlist();
    },
    handleSize(val) {
      this.getlist();
    },
    //获取列表
    getlist() {
      let data = {
        activityName: this.search.activityName,
        state: 6,
        regionName: "",
        startTime: this.search.startTime,
        endTime: this.search.endTime,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      };
      applylist(data).then((res) => {
        this.tableData = res.data.rows;
        this.pagination.pageSize = res.data.pageSize;
        this.pagination.pageNum = res.data.pageNum;
        this.pagination.total = res.data.total;
      });
    },
    //查看详情
    getuserdetails(rows) {
      localStorage.setItem("id", rows.applyId);
      localStorage.setItem("templateDataId", rows.templateDataId);
      localStorage.setItem("templateId", rows.templateId);

      if (rows.activityId) {
        localStorage.setItem("activityId", rows.activityId);
        this.$router.push({ path: "/web/home" });
      }
      localStorage.setItem("states", 1);
      //
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .box {
    height: 100%;
    width: 100%;
    margin: auto;
    overflow-y: scroll;
    .base {
      padding: 30px 48px;
      font-size: 16px;
      ul {
        li {
          span {
            float: none;
          }
        }
      }
      li {
        color: rgba(252, 82, 76, 1);
        line-height: 34px;
        // &:nth-of-type(2) {
        //   padding-left: 32px;
        // }
        // &:nth-of-type(3) {
        //   padding-left: 32px;
        // }
      }
    }
    .search-box {
      margin: 40px 48px;
      display: flex;
      div {
        margin-left: 20px;
        &:first-of-type {
          margin-left: 0px;
        }
        .el-input {
          width: 210px;
          height: 42px;
          border-radius: 8px;
          .el-input__inner {
            background: rgba(243, 244, 250, 1);
            color: rgba(146, 152, 166, 1);
          }
        }
      }
    }
    .formbox {
      width: 90%;
      margin: 40px 48px;
      .el-pagination {
        padding: 2px 0px;
      }
    }
  }
}
</style>


